// extracted by mini-css-extract-plugin
export var active = "modal-module--active--Ohaia";
export var backdrop = "modal-module--backdrop--q8qs2";
export var body = "modal-module--body--1sM0q";
export var close_button = "modal-module--close_button--JzgiB";
export var close_button_centered = "modal-module--close_button_centered--1eToG";
export var content = "modal-module--content--6qO8r";
export var description = "modal-module--description--qaV+p";
export var hasFooter = "modal-module--hasFooter--BQBXR";
export var header = "modal-module--header--TrxO4";
export var main_header = "modal-module--main_header--I7sJd";
export var mobile_menu = "modal-module--mobile_menu--16Yu9";
export var modal = "modal-module--modal--62XF+";
export var modal_centered = "modal-module--modal_centered--BFVvt";
export var modal_side = "modal-module--modal_side--NkWYt";